var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-file-input',_vm._g(_vm._b({attrs:{"prepend-icon":"","prepend-inner-icon":"ic ic-20 ic-file ic-col-grey","dense":"","outlined":"","hide-details":"auto","clearable":""}},'v-file-input',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }